"use client";

import { useState } from "react";
import { Category } from "../types/categories";

interface CategoryFormProps {
  initialData?: Partial<Category>;
  onSubmit: (data: Partial<Category>) => void;
  onCancel: () => void;
}

export default function CategoryForm({
  initialData = {},
  onSubmit,
  onCancel,
}: CategoryFormProps) {
  const [formData, setFormData] = useState<Partial<Category>>(initialData);

  const handleChange = (field: keyof Category, value: any) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Left: Image */}
      <div className="flex flex-col items-center justify-center border rounded-lg bg-gray-50 h-[250px]">
        {formData.image ? (
          <img
            src={formData.image}
            alt="Category"
            className="w-full h-full object-cover rounded"
          />
        ) : (
          <div className="flex flex-col items-center text-gray-400">
            <img
              src="/no-image.png"
              alt="No image"
              className="w-20 h-20 opacity-70 mb-2"
            />
            <span>No Image</span>
          </div>
        )}
      </div>

      {/* Right: Fields */}
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Category Name
          </label>
          <input
            type="text"
            value={formData.name || ""}
            onChange={(e) => handleChange("name", e.target.value)}
            className="w-full border rounded-lg px-4 py-2 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#885ABB]/20"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Category Color
          </label>
          <input
            type="text"
            value={(formData as any).color || ""}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, color: e.target.value }))
            }
            className="w-full border rounded-lg px-4 py-2 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#885ABB]/20"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Category Slug
          </label>
          <input
            type="text"
            value={(formData as any).slug || ""}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, slug: e.target.value }))
            }
            className="w-full border rounded-lg px-4 py-2 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#885ABB]/20"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Status
          </label>
          <select
            value={formData.status || "active"}
            onChange={(e) => handleChange("status", e.target.value)}
            className="w-full border rounded-lg px-4 py-2 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#885ABB]/20"
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </div>

      {/* Footer */}
      <div className="md:col-span-2 flex flex-col sm:flex-row justify-end gap-3 mt-4">
        <button
          onClick={onCancel}
          className="order-2 sm:order-1 px-6 py-3 border border-gray-300 rounded-xl text-gray-700 font-bold hover:bg-gray-50 transition-all shadow-sm"
        >
          Cancel
        </button>
        <button
          onClick={() => onSubmit(formData)}
          className="order-1 sm:order-2 px-6 py-3 bg-[#885ABB] hover:bg-[#6f47a2] text-white rounded-xl font-bold transition-all shadow-md hover:shadow-lg"
        >
          Save Category
        </button>
      </div>
    </div>
  );
}
